var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 59,
    viewBox: "0 0 51 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7352 6.26302C38.7352 4.71592 38.1206 3.23219 37.0266 2.13823C35.9327 1.04427 34.449 0.429688 32.9019 0.429688H16.6094C15.0624 0.430018 13.5789 1.04482 12.4852 2.13885L2.52769 12.0964C1.43365 13.1901 0.818854 14.6736 0.818523 16.2205V41.263C0.818523 42.8101 1.43311 44.2938 2.52707 45.3878C3.62103 46.4818 5.10476 47.0964 6.65186 47.0964H12.4852V52.9297C12.4852 54.4768 13.0998 55.9605 14.1937 57.0545C15.2877 58.1484 16.7714 58.763 18.3185 58.763H44.5685C46.1156 58.763 47.5993 58.1484 48.6933 57.0545C49.7873 55.9605 50.4019 54.4768 50.4019 52.9297V17.9297C50.4019 16.3826 49.7873 14.8989 48.6933 13.8049C47.5993 12.7109 46.1156 12.0964 44.5685 12.0964H38.7352V6.26302ZM6.65186 41.263H32.9019V6.26302H21.2352V16.4714C21.2352 17.6317 20.7743 18.7445 19.9538 19.5649C19.1333 20.3854 18.0205 20.8464 16.8602 20.8464H6.65186V41.263ZM7.85936 15.013H15.4019V7.47052L7.85936 15.013ZM38.7352 41.263V17.9297H44.5685V52.9297H18.3185V47.0964H32.9019C34.449 47.0964 35.9327 46.4818 37.0266 45.3878C38.1206 44.2938 38.7352 42.8101 38.7352 41.263Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.1f00fa7506714b91ff40f0ee99a2a2e2.svg";
export { ForwardRef as ReactComponent };